// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8c52b4df","453":"8d125d16"}[chunkId] + ".chunk.js";
};